<template>
  <PageAltContent>
    <div class="flex justify-between gap-4 hidden xl:flex">
      <div class="w-2/3">
        <QuickListEvents />
      </div>
      <div class="w-1/3">
        <QuickListLocations />
      </div>
    </div>

    <!-- Mobile -->
    <div class="flex flex-col justify-between gap-4 xl:hidden">
      <div class="">
        <QuickListEvents />
      </div>
      <div class="flex flex-col justify-between">
        <QuickListLocations />
      </div>
    </div>
  </PageAltContent>
</template>

<script setup>
import PageAltContent from "@/components/page/PageAltContent.vue";
import { QuickListEvents, QuickListLocations } from ".";

import { useEventsStore } from "@/store/events.js";
const eventsStore = useEventsStore();

import brandconfig from "@/brandconfig";
eventsStore.fetchPopular(brandconfig);
eventsStore.fetchUpcoming(brandconfig);
eventsStore.fetchNewEvents(brandconfig);
</script>
